module.exports = __webpack_public_path__ + "static/img/sqtgh5.8e2e3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sqtgh5.png
// module id = VNim
// module chunks = 0